const configBoardFilter = {
    memberQa: {
        listApiParamSet: {
            ip: 1,
            sp: 10,
            page: 1,
        },
        pageRow: 10,
        paginationType: 'pagination',
        getFunc: 'getQaList',
        isCategory: true,
        getCategoryFunc: 'getQaCategoryList',
        keyName: '',
    },
    faq: {
        listApiParamSet: {
            ip: 1,
            sp: 10,
            page: 1,
        },
        pageRow: 10,
        paginationType: 'pagination',
        getFunc: 'getFaqList',
        isCategory: false,
        getCategoryFunc: '',
        keyName: 'fa_idx',
        deleteFunc: 'deleteFaq',
        deleteApiParamsSet: {},
        deleteSuccessType: 1,
        deleteFailTypes: {},
    },
    writeFaq: {
        writeFunc: 'createFaq',
        writeApiParamSet: {},
        getCategoryFunc: '',
        parsingData: {
            title: 'fa_subject',
            content: 'fa_content',
        },
        keyName: '',
        directUrl: '',
        directType: 'back',
        writeSuccessType: 1,
        writeFailTypes: {
            100: '보내는 값이 잘못 되었습니다.'
        },
        writeFailMsg: '게시글을 등록 할 수 없습니다.',
    },
    updateFaq: {
        getFunc: 'getFaqList',
        detailApiParamSet: {
            ip: 0,
        },
        getCategoryFunc: '',
        writeFunc: 'updateFaq',
        writeApiParamSet: {},
        parsingData: {
            title: 'fa_subject',
            content: 'fa_content',
        },
        directUrl: '',
        directType: 'back',
        writeSuccessType: 1,
        writeFailTypes: {
            100: '보내는 값이 잘못 되었습니다.'
        },
        writeFailMsg: '게시글을 수정 할 수 없습니다.',
        keyName: 'fa_idx',
    },
    qa: {
        getFunc: 'getQaList',
        listApiParamSet: {
            ip: 1,
            sp: 10,
            page: 1,
        },
        pageRow: 10,
        paginationType: 'pagination',
        isCategory: true,
        getCategoryFunc: 'getQaCategoryList',
        keyName: 'qa_idx',
        deleteFunc: 'deleteAnswerQa',
        deleteApiParamsSet: {},
        deleteSuccessType: 1,
        deleteFailTypes: {},
    },
    writeQa: {
        writeFunc: 'createAnswerQa',
        writeApiParamSet: {
        },
        getCategoryFunc: '',
        parsingData: {
            answerTitle: 'qa_subject',
            answerContent: 'qa_content',
        },
        directUrl: '',
        directType: 'back',
        writeSuccessType: 1,
        writeFailTypes: {
            100: '보내는 값이 잘못 되었습니다.'
        },
        writeFailMsg: '답변을 등록 할 수 없습니다.',
        keyName: 'qa_parent',
    },
    updateQa : {
        getFunc: 'getQaList',
        detailApiParamSet: {
            ip: 0,
            opa: 1,
            opf: 1,
        },
        getCategoryFunc: '',
        writeFunc: 'updateAnswerQa',
        writeApiParamSet: {},
        parsingData: {
            answerTitle: 'qa_subject',
            answerContent: 'qa_content',
        },
        directUrl: '',
        directType: 'back',
        writeSuccessType: 1,
        writeFailTypes: {
            100: '보내는 값이 잘못 되었습니다.'
        },
        writeFailMsg: '답변을 수정 할 수 없습니다.',
        keyName: 'qa_idx',
    },
    notice: {
        listApiParamSet: {
            ip: 1,
            sp: 10,
            page: 1,
            pa: 0,
            wr_type: 'post',
            type: 'post',
        },
        pageRow: 10,
        paginationType: 'pagination',
        getFunc: 'getNoticeList',
        isCategory: false,
        getCategoryFunc: '',
        keyName: 'wr_id',
        deleteFunc: 'deleteNotice',
        deleteApiParamsSet: {
            type: 'post',
        },
        deleteSuccessType: 1,
        deleteFailTypes: {},
    },
    writeNotice: {
        writeFunc: 'createNotice',
        writeApiParamSet: {
            wr_type: 'post',
            type: 'post',
        },
        getCategoryFunc: '',
        parsingData: {
            title: 'wr_subject',
            content: 'wr_content',
        },
        keyName: '',
        directUrl: '',
        directType: 'back',
        writeSuccessType: 1,
        writeFailTypes: {
            100: '보내는 값이 잘못 되었습니다.'
        },
        writeFailMsg: '게시글을 등록 할 수 없습니다.',
    },
    updateNotice: {
        getFunc: 'getNoticeList',
        detailApiParamSet: {
            ip: 0,
            wr_type: 'post',
            type: 'post',
        },
        getCategoryFunc: '',
        writeFunc: 'updateNotice',
        writeApiParamSet: {
            wr_type: 'post',
            type: 'post',
        },
        parsingData: {
            title: 'wr_subject',
            content: 'wr_content',
        },
        directUrl: '',
        directType: 'back',
        writeSuccessType: 1,
        writeFailTypes: {
            100: '보내는 값이 잘못 되었습니다.'
        },
        writeFailMsg: '게시글을 수정 할 수 없습니다.',
        keyName: 'wr_id',
    },
}

export default {
    methods: {
        returnBoardFilterConfig(type) {
            return configBoardFilter[type];
        },
    },

    filterConfig: {
        cr: { // 작성일
            type: 'between',
            classname: 'filterDate',
        },

        su: { // 제목
            type: 'query',
            classname: 'searchInput',
        },

        co: { // 내용
            type: 'query',
            classname: 'searchInput',
        },

        ni: { // 닉네임
            type: 'query',
            classname: 'searchInput',
        },

        na: { // 이름
            type: 'query',
            classname: 'searchInput',
        },

        mid: { // 아이디
            type: 'query',
            classname: 'searchInput',
        },

        isan: { // 답변 상태
            type: 'match',
            classname: 'filterStatus',
        },

        cid: { // 문의 분류
            type: 'match',
            classname: 'filterCate',
        },
        tab: {
            type: 'noFilter',
            classname: 'tab',
        },
    }

}
